export default {
  init() {
    this.events();
  },

  events() {
    // Procurement on enter, search
    $(document).on('keyup', (e) => {
      if (e.key == 'Enter') {
        $('.auction-filter').trigger('submit');
      }
    });
    $(document).on('click', '.form-field--search .form-field__icon', () => {
      $('.auction-filter').trigger('submit');
    });

    $('.filter-button--open').on('click', () => {
      $('.filter').addClass('open');
    });
    $('.filter-button--close').on('click', () => {
      $('.filter').removeClass('open');
    });

    // On category change
    $('.filter input[type=checkbox]').on('change', (e) => {
      const input = $(e.currentTarget);
      if (input.val() == '') {
        input.closest('label').siblings().find('input').prop('checked', false);
      } else {
        $('.filter input[type=checkbox][value=""]').prop('checked', false);
      }
    });

    // Clear form
    $('.filter__clear').on('click', (e) => {
      e.preventDefault();
      const form = $(e.currentTarget).closest('.filter');
      window.location = form.attr('action');
    });

    // Handle form
    $('.filter').on('submit', (e) => {
      e.preventDefault();

      const form = $(e.currentTarget);

      this.handleFormSubmit(form);
    });
  },

  handleFormSubmit(form) {
    let params = {};

    // Search
    const search = $('.filter-search input');
    if (search.val()) {
      params.search = search.val();
    }

    // Categories
    const categoriesEl = form.find('input[name=category]');
    let categories = this.constructParams(categoriesEl);
    if (categories.length) {
      params.categories = categories.join(',');
    }

    // Type
    const typesEl = form.find('input[name=types]');
    let types = this.constructParams(typesEl);
    if (types.length) {
      params.types = types.join(',');
    }

    // Dates
    const date = form.find('input[name=calendar]');
    if (date.val()) {
      params.date = date.val();
    }

    if (
      !$('body').hasClass('page-template-template-events') &&
      categories.length == 1 &&
      !params.search &&
      !params.date &&
      !params.types
    ) {
      window.location = form.data('cat') + '/' + categories[0];
      return;
    }

    // Status
    const statusEl = form.find('input[name=status]');
    let status = this.constructParams(statusEl);
    if (status.length) {
      params.status = status.join(',');
    }

    // Procedure
    const procedureEl = form.find('input[name=procedure]');
    let procedure = this.constructParams(procedureEl);
    if (procedure.length) {
      params.procedure = procedure.join(',');
    }

    // Create url
    let query = '';
    Object.keys(params).forEach((key, i) => {
      query += key + '=' + params[key];
      if (i < Object.keys(params).length) {
        query += '&';
      }
    });

    let url = form.attr('action');

    if (query) {
      window.location = url + '?' + query;
    } else {
      window.location = url;
    }
  },

  constructParams(fields) {
    let terms = [];
    fields.each((_i, field) => {
      field = $(field);
      if (field.val() && field.prop('checked')) {
        terms.push(field.val());
      }
    });

    return terms;
  },
};
